import { render, staticRenderFns } from "./ListProductionsProd.vue?vue&type=template&id=85d56d54&scoped=true&"
import script from "./ListProductionsProd.vue?vue&type=script&lang=js&"
export * from "./ListProductionsProd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85d56d54",
  null
  
)

export default component.exports